import { ThemeColorsKeys } from '../../../styles/tokens/colors';

export default {
  backgroundColor: 'utilityWhite',
} as Record<string, ThemeColorsKeys>;
